import { render, staticRenderFns } from "./StatisticsCard.vue?vue&type=template&id=4a2d2774&scoped=true&"
import script from "./StatisticsCard.vue?vue&type=script&lang=js&"
export * from "./StatisticsCard.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCard.vue?vue&type=style&index=0&id=4a2d2774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d2774",
  null
  
)

export default component.exports